/* 
Mochi Rage

Samples produced by Sam Zabala using Alchemy and Multi Sampler Software Instruments from Garageband / Logic Pro
Original Voice Recordings by Mochi Franziska Von Karma Zabala
Not for redistribution, resale or reuse
*/

import C0 from '/sounds/mochi/C0.mp3'
import F0 from '/sounds/mochi/F0.mp3'
import C2 from '/sounds/mochi/C2.mp3'
import F2 from '/sounds/mochi/F2.mp3'
import C4 from '/sounds/mochi/C4.mp3'
import F4 from '/sounds/mochi/F4.mp3'
import C6 from '/sounds/mochi/C6.mp3'
import F6 from '/sounds/mochi/F6.mp3'
import C8 from '/sounds/mochi/C8.mp3'
import F8 from '/sounds/mochi/F8.mp3'

export default {
	C0,
	F0,
	C2,
	F2,
	C4,
	F4,
	C6,
	F6,
	C8,
	F8,
}
